/**
 * Export `FormDataProps` type.
 */

export type FormDataProps = {
  company: string;
  country: string;
  email: string;
  gas_type?: string | null;
  message?: string | null;
  name: string;
  phone?: string | null;
  position?: string | null;
  recaptcha_token: string;
  subject: string;
  subscribe_to_newsletter: boolean;
  technology_type?: string[] | null;
};

/**
 * Export `subjectValues`.
 */

export const subjectValues = {
  humanResources: 'human_resources',
  institutional: 'institutional',
  media: 'media',
  others: 'others',
  partnerships: 'partnerships'
};

/**
 * Export `Subject` type.
 */

export type Subject = keyof typeof subjectValues;

/**
 * Export `Error` type.
 */

export type Error = {
  message?: string;
  type: string;
};
